export default {  
  methods: {  
    addAnswer(){
      if(this.validateCharactersAmountLimit()) return;
      if(this.textAreaContent === "") return;
      const theAnswerAlreadyExists = this.listAnswers.find(answer => answer.questionNumber === this.numberQuestion);
      theAnswerAlreadyExists === undefined ? this.addANewAnswer() : this.updateAOldAnswer(theAnswerAlreadyExists);
      this.handleUpdateDescriptionOffender();
      // this.verifyAmountRequiredOfAnswers();
    },
    validateCharactersAmountLimit(){
      let exceded = false;
      if(
        this.textAreaContent.length > 100 &&
        (
          this.numberQuestion === 7 || this.numberQuestion === 11 || this.numberQuestion === 12 || 
          this.numberQuestion === 13
        )
      ) {
        exceded = true;
      }
      return exceded;
    },
    // Función para verificar la 6 respuestas obligatorias y agregar o quitar el error según corresponda
    // verifyAmountRequiredOfAnswers(){
    //   if(this.listAnswers.length === 6 || this.listAnswers.length > 6){
    //     this.errores.identikit = null;
    //   } else{
    //     this.errores.identikit = 'El identikit debe tener al menos 6 preguntas respondidas';
    //   }
    //   this.$emit("validationStatus", this.errores);
    // },
    addANewAnswer(){
      this.listAnswers.push({
        question: this.questions[this.numberQuestion - 1], 
        questionNumber: this.numberQuestion, 
        answer: "Respuesta P." + this.numberQuestion  + ": " + this.textAreaContent,
        answerToTextAreaContent: this.textAreaContent
      })
    },
    updateAOldAnswer(theAnswerAlreadyExists){
      let indexQuestion = this.listAnswers.indexOf(theAnswerAlreadyExists)
      this.listAnswers[indexQuestion] = {
        question: this.questions[this.numberQuestion - 1], 
        questionNumber: this.numberQuestion, 
        answer: "Respuesta P." + this.numberQuestion  + ": " + this.textAreaContent,
        answerToTextAreaContent: this.textAreaContent
      };
    },
    fillTextAreaContent() {
      this.textAreaContent = '';
      const generators = {
        1: this.generateClothingDescription,
        2: this.generateHairDescription,
        3: this.generateTextureDescription,
        4: this.generateAgeDescription,
        5: this.generateTattooDescription,
        8: this.generateAccessoryDescription,
        9: this.generateMobilityDescription,
        10: this.generateWeaponDescription,
      };
      const generator = generators[this.numberQuestion];
      if (generator) {
        this.textAreaContent = generator.call(this);
      }
      this.sanitizeEmptyTextContent();
    },
    sanitizeEmptyTextContent() {
      const placeholders = ['Vestía ', 'Tenía cabello ', 'Portaba '];
      if (placeholders.includes(this.textAreaContent)) {
        this.textAreaContent = '';
      }
    },
    generateClothingDescription() {
      const parts = [
        this.headPhrase && this.headPhrase + ',',
        this.sBodyPhrase && this.sBodyPhrase + ',',
        this.iBodyPhrase && this.iBodyPhrase + ',',
        this.feetPhrase || ''
      ].filter(Boolean);
      return 'Vestía ' + parts.join(' ');
    },
    generateHairDescription() {
      return this.hairPhrase ? 'Tenía cabello ' + this.hairPhrase + ' ' : '';
    },
    generateTextureDescription() {
      return this.texturePhrase ? 'Una persona ' + this.texturePhrase + ' ' : '';
    },
    generateAgeDescription() {
      return this.agePhrase ? 'Era ' + this.agePhrase + ' ' : '';
    },
    generateTattooDescription() {
      const phrases = this.getTattooPhrases();
      if (phrases.length === 0) return '';
      const { withArticle } = phrases[0];
      const isFeminine = withArticle?.charAt(3) === 'a';
      let result = isFeminine ? 'Tatuada ' : 'Tatuado ';
      result += withArticle + ' ';
      for (let i = 1; i < phrases.length; i++) {
        result += phrases[i].noArticle + ' ';
      }
      return result.trim();
    },
    getTattooPhrases() {
      const keys = ['Head', 'Body', 'Arm', 'Leg'];
      return keys.map(k => {
        const withArticle = this[`tatoo${k}Phrase`]?.withArticle;
        const noArticle = this[`tatoo${k}Phrase`]?.noArticle;
        if (withArticle || noArticle) {
          return {
            withArticle: withArticle ? withArticle + ',' : '',
            noArticle: noArticle ? noArticle + ',' : ''
          };
        }
        return null;
      }).filter(Boolean);
    },
    generateAccessoryDescription() {
      return this.personalAccessoryPhrase ? 'Portaba ' + this.personalAccessoryPhrase + ' ' : '';
    },
    generateMobilityDescription() {
      return this.mobilityPhrase ? 'Se trasladaba ' + this.mobilityPhrase + ' ' : '';
    },
    generateWeaponDescription() {
      return this.weaponPhrase || '';
    },
    createPhrase(phraseType) {
      const generators = {
        1: this.generatePhraseForQuestion1,
        2: this.generatePhraseForQuestion2,
        3: this.generatePhraseForQuestion3,
        4: this.generatePhraseForQuestion4,
        5: this.generatePhraseForQuestion5,
        8: this.generatePhraseForQuestion8,
        9: this.generatePhraseForQuestion9,
        10: this.generatePhraseForQuestion10,
      };
      if (generators[this.numberQuestion]) {
        generators[this.numberQuestion].call(this, phraseType);
        this.fillTextAreaContent();
      }
    },
    generatePhraseForQuestion1(phraseType) {
      const garmentObj = this[phraseType + 'Garment'];
      const sleevesObj = this[phraseType + 'Sleeves'];
      const footwearObj = this[phraseType + 'Footwear'];
      const styleObj = this[phraseType + 'Style'];
      const colorStr = this[phraseType + 'Color'];
      const garment = garmentObj ? garmentObj.article + ' ' + garmentObj.nombre.toLowerCase() : '';
      const sleeves = sleevesObj ? sleevesObj.nombre.toLowerCase() : '';
      const footwear = footwearObj ? footwearObj.article + ' ' + footwearObj.nombre.toLowerCase() : '';
      const style = styleObj ? styleObj.nombre.toLowerCase() : '';
      const color = colorStr ? 'de color ' + colorStr.toLowerCase().replaceAll('-', '') : '';
      const parts = [garment, sleeves, footwear, style, color].filter(Boolean);
      this[phraseType + 'Phrase'] = parts.join(' ');
    },
    generatePhraseForQuestion2(phraseType) {
      const length = this[phraseType + 'Length']?.nombre.toLowerCase() || '';
      const color = this[phraseType + 'Color'] ? 'de color ' + this[phraseType + 'Color'].toLowerCase().replaceAll('-', '') : '';
      const type = this[phraseType + 'Type']?.nombre.toLowerCase() || '';
      const parts = [length, type, color].filter(Boolean);
      this[phraseType + 'Phrase'] = parts.join(' ');
    },
    generatePhraseForQuestion3(phraseType) {
      const gender = this.gender?.nombre ? 'de sexo ' + this.gender.nombre.toLowerCase() : '';
      const height = this.height?.nombre ? 'de estatura ' + this.height.nombre.toLowerCase() + ',' : '';
      const volume = this.volume ? (
        this.gender?.nombre === 'Masculino'
          ? ' ' + this.volume.male.toLowerCase() + ','
          : ' ' + this.volume.femenine.toLowerCase() + ','
      ) : '';
      const approximateHeight = this.approximateHeight ? 'estatura aproximada de ' + this.approximateHeight + ' cm' : '';
      const parts = [gender, height, volume, approximateHeight].filter(Boolean);
      this[phraseType + 'Phrase'] = parts.join(' ');
    },
    generatePhraseForQuestion4(phraseType) {
      const stageOfLife = this.stageOfLife?.nombre ? 'un ' + this.stageOfLife.nombre.toLowerCase() : '';
      const approximateAge = this.approximateAge ? 'de ' + this.approximateAge + ' años aproximadamente' : '';
      const parts = [stageOfLife, approximateAge].filter(Boolean);
      this[phraseType + 'Phrase'] = parts.join(' ');
    },
    generatePhraseForQuestion5(phraseType) {
      const phrase = "tatoo" + phraseType.charAt(0).toUpperCase() + phraseType.slice(1) + "Phrase";
      this[phrase] = { noArticle: '', withArticle: '' };
    
      const part = this[phraseType + "Part"];
      const side = this[phraseType + "Side"];
      const zone = this[phraseType + "Zone"];
      const type = this[phraseType + "Type"];
    
      const partStr = part ? ' en ' + part.article.toLowerCase() + ' ' + part.nombre.toLowerCase() : '';
      const sideStr = side ? (part?.article === 'la' ? side.nombre.toLowerCase() + ' ' : side.male.toLowerCase() + ' ') : '';
      const zoneStr = zone ? 'en la zona ' + zone.toLowerCase().replaceAll('-', '') : '';
      const typeStr = type ? ' ' + type.article.toLowerCase() + ' ' + type.nombre.toLowerCase() : '';
      const typeNoArticle = type ? 'otro de tipo ' + type.nombre.toLowerCase() : '';
    
      const withArticle = [typeStr, partStr, sideStr, zoneStr].filter(Boolean).join(' ');
      const noArticle = [typeNoArticle, partStr, sideStr, zoneStr].filter(Boolean).join(' ');
    
      this[phrase].withArticle = withArticle;
      this[phrase].noArticle = noArticle;
    },
    generatePhraseForQuestion8(phraseType) {
      const accessory = this.accessory?.article + ' ' + this.accessory?.nombre.toLowerCase() || '';
      const part = this.part?.nombre ? 'en su ' + this.part.nombre.toLowerCase() : '';
      const zone = this.zone ? (
        !this.part || this.part.gender === "femenine"
          ? this.zone.nombre.toLowerCase().replaceAll('-', '')
          : this.zone.male.toLowerCase().replaceAll('-', '')
      ) : '';
      const color = this.color ? 'de color ' + this.color.toLowerCase().replaceAll('-', '') : '';
      const parts = [accessory, part, zone, color].filter(Boolean);
      this[phraseType + 'Phrase'] = parts.join(' ');
    },
    generatePhraseForQuestion9(phraseType) {
      const mobility = this.mobility?.article + ' ' + this.mobility?.nombre.toLowerCase() || '';
      const mobilityType = this.mobilityType?.nombre.toLowerCase() || '';
      const brand = this.brand?.nombre ? 'marca ' + this.brand.nombre : '';
      const mobilityColor = this.mobilityColor ? 'de color ' + this.mobilityColor.toLowerCase().replaceAll('-', '') : '';
      const parts = [mobility, mobilityType, brand, mobilityColor].filter(Boolean);
      this[phraseType + 'Phrase'] = parts.join(' ');
    },
    generatePhraseForQuestion10(phraseType) {
      const weaponElement = this.weaponElement?.article + ' ' + this.weaponElement?.nombre.toLowerCase() || '';
      const weaponCaliber = this.weaponCaliber ? 'de calibre ' + this.weaponCaliber + ' mm' : '';
      const weaponColor = this.weaponColor ? 'de color ' + this.weaponColor.toLowerCase().replaceAll('-', '') : '';
      const parts = [weaponElement, weaponCaliber, weaponColor].filter(Boolean);
      this[phraseType + 'Phrase'] = parts.join(' ');
    },
    selectOptionsMultiSelect(value, multiSelectData){
      //Si no hay opciones seleccionadas previamente, simplemente se agrega la nueva opción
      if(this[multiSelectData.nameMultiSelect].length === 0){
        //Verificar si la nueva opción tiene "género"
        this[multiSelectData.nameMultiSelect].push(multiSelectData.genders ? value : value.nombre);
        this[multiSelectData.nameString] = this[multiSelectData.nameMultiSelect][0];
        return;
      }
      //Si ya hay opciones agregadas, se evalúa si hay que quitar una opción vieja o agregar una nueva
      if(this[multiSelectData.nameMultiSelect].length > 0){
        this.addOrRemoveAOption(value, multiSelectData);
      }
    },
    addOrRemoveAOption(value, multiSelectData){
      const indexOption = this.verifyIfTheOptionAlreadyExists(value, multiSelectData);
      if(indexOption === false){
        //La opción no existía previamente, se evalúa si hay que actualizar o agregarla como opción nueva
        this[multiSelectData.nameMultiSelect][indexOption] === undefined ? this[multiSelectData.nameMultiSelect].push(value.nombre) :  this[multiSelectData.nameMultiSelect][indexOption] = value.nombre
        this.createString(multiSelectData);
      } else{
        //Se ingresó una opción ya existente, lo que significa que hay que eliminarla
        this[multiSelectData.nameMultiSelect].splice(indexOption, 1);
        this[multiSelectData.nameMultiSelect][0] === undefined ? this[multiSelectData.nameString] = null : this.createString(multiSelectData);
      }
    },
    verifyIfTheOptionAlreadyExists(value, multiSelectData){
      let alreadyExists;
      if(multiSelectData.genders){
        alreadyExists = this[multiSelectData.nameMultiSelect].find( option => option === value[multiSelectData.genders[0]] || 
          option === value[multiSelectData.genders[1]] || 
          option[multiSelectData.genders[0]] === value[multiSelectData.genders[0]] || 
          option[multiSelectData.genders[1]] === value[multiSelectData.genders[1]]
        )
      } else {
        alreadyExists = this[multiSelectData.nameMultiSelect].find(option => option === value.nombre)
      }
      let indexOption = this[multiSelectData.nameMultiSelect].indexOf(alreadyExists);
      return alreadyExists === undefined ? false : indexOption;
    },
    createString(multiSelectData){
      if(multiSelectData.genders){ 
        this.makeStringWithGender(multiSelectData);
      } else{
        this.makeStringWithoutGender(multiSelectData.nameString, multiSelectData.nameMultiSelect);
      }
    },
    makeStringWithGender({genders, nameMultiSelect, nameString}){
      this[nameString] = { [genders[0]]: '', [genders[1]]: '' }
      let optionOfList 
      let indexOption 
      let trueOption 
      let i = 0
      this[nameMultiSelect].map( option => {
        trueOption = typeof option === 'object' ? option[genders[0]] : option
        optionOfList = this[nameString + "List"].find(element => element[genders[0]] === trueOption)
        indexOption = this[nameString + "List"].indexOf(optionOfList)
        if(i === 0){
          this[nameString][genders[0]] = this[nameString + "List"][indexOption][genders[0]] 
          this[nameString][genders[1]] = this[nameString + "List"][indexOption][genders[1]] 
        } else{
          this[nameString][genders[0]] = this[nameString][genders[0]] + ' - ' + this[nameString + "List"][indexOption][genders[0]] 
          this[nameString][genders[1]] = this[nameString][genders[1]] + ' - ' + this[nameString + "List"][indexOption][genders[1]] 
        }
        i++
      })
    },
    makeStringWithoutGender(nameString, nameMultiSelect){
      this[nameString] = ''
      let i = 0
      this[nameMultiSelect].map( option => {
        if(i === 0){
          this[nameString] = option
        } else{
          this[nameString] = this[nameString] + ' - ' + option
        }
        i++
      })
    },
    updateListAnwserWithStore(){
      let offender =  this.getAcusadoByArrId(this.$router.currentRoute.query.id)
      if(offender === undefined){
        this.listAnswers = []
      } else{
        this.listAnswers = [ ...offender.identikit ]
        this.listAnswers = this.listAnswers.map(obj => Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, k === 'questionNumber' && !isNaN(Number(v)) ? Number(v) : v])));
      }
    },
    deleteAnswer(question){
      let indexQuestion = this.listAnswers.indexOf(question)
      this.listAnswers.splice(indexQuestion, 1)
      this.handleUpdateDescriptionOffender()
      this.textAreaContent = ''
    },
    canRevert(questionNumber) {
      let originalAnswer = this.originalAnswersWithoutEdit.find(answer => answer?.questionNumber === questionNumber);
      originalAnswer = originalAnswer?.answer;
      const currentAnswer = this.textAreaContent
      let answerUpdated = this.listAnswers.find(answer => answer.questionNumber === questionNumber);
      answerUpdated = answerUpdated?.answer
      // return !!originalAnswer && originalAnswer.split(":")[1].trim() !== currentAnswer; // Retorna true si hay cambios
      return !!originalAnswer && originalAnswer.trim() !== answerUpdated.trim();
    },
    revertAnswer(event, questionNumber){
      this.$confirm.require({
        target: event.currentTarget,
        message: '¿Está seguro que quiere restablecer la descripción?',
        icon: 'pi pi-question-circle',
        acceptClass: "p-button-danger",
        acceptLabel: "Sí",
        rejectLabel: "No",
        accept: () => {
          this.numberQuestion = questionNumber;
          // this.$store.dispatch('sumario/acusados/revertToOriginalIdentikitQuestion', {
          //   arrId: this.arrId,
          //   questionNumber: questionNumber
          // })
          // const originalAnswer = this.$store.getters['sumario/acusados/getOriginalAnswerByQuestion'](this.arrId, questionNumber);
          let originalAnswer = this.originalAnswersWithoutEdit.find(answer => answer.questionNumber === questionNumber);
          originalAnswer = originalAnswer?.answer;
          this.textAreaContent = originalAnswer.split(":")[1].trim()
          this.updateAnswer();
        },
        reject: () => { }
      });
    },
    editAnswer(event, question){
      this.$confirm.require({
        target: event.currentTarget,
        message: '¿Está seguro que quiere editar la descripción?',
        icon: 'pi pi-question-circle',
        acceptClass: "p-button-danger",
        acceptLabel: "Sí",
        rejectLabel: "No",
        accept: () => {  
          this.saveForFirstTime();
          const arrId = this.arrId; 
          let answerToEdit = this.listAnswers.filter(answer => answer.questionNumber === question)
          // this.$store.dispatch('sumario/acusados/saveOriginalIdentikitQuestion', {
          //   arrId,
          //   questionNumber: question,
          //   answer: answerToEdit[0].answer
          // });
          this.numberQuestion = question
          // trim the phrase 'Repuesta P...'
          answerToEdit = answerToEdit[0].answer.replace(`Respuesta P.${question}: `, '')
          this.textAreaContent = answerToEdit
          this.$refs.textAreaContentHTML.$el.focus()
          window.scrollTo(0,0)
        },
        reject: () => { }
      });
    },
    confirmDelete(event, question){
      this.$confirm.require({
        target: event.currentTarget,
        message: '¿Está seguro que quiere eliminar la descripción?',
        icon: 'pi pi-question-circle',
        acceptClass: "p-button-danger",
        acceptLabel: "Sí",
        rejectLabel: "No",
        accept: () => {
          try {
            this.deleteAnswer(question);
            // this.verifyAmountRequiredOfAnswers();
          } catch (error) {
            console.error("Error al eliminar el archivo:", error);
          } 
        },
        reject: () => { }
      }); 
    },
    updateAnswer(){
      this.addAnswer()
      this.$store.dispatch("sumario/textResetEditsCounter","Contravener")
      this.$emit("updateValue", "numberQuestion", this.numberQuestion)
    },  
  }
};